import SuburbSummary from './suburb-summary';
import SuburbSummaryGraphQL from './suburb-summary-graphql';
export default SuburbSummary;
export { SuburbSummaryGraphQL };